import PAGES_LINKS from '../../pages/constants/index'
const routingMappingDic = {
  10000: PAGES_LINKS.home.root,
  10001: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.plansDetails}`,
  10002: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.bundlePage}?catType=internet`,
  10003: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.bundlePage}?catType=minutes`,
  10004: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.bundlePage}?catType=sms`,
  10005: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.bundlePage}?catType=others`,
  10006: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.allOffers}`,
  10009: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.payBills}`,
  10011: `${PAGES_LINKS.home.root}${PAGES_LINKS.quickAccess.freeSMS}`,
  10010: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.RechargeBalance}`,
  10012: `${PAGES_LINKS.home.root}${PAGES_LINKS.quickAccess.usage}`,
  10013: `${PAGES_LINKS.home.root}${PAGES_LINKS.home.payBills}${PAGES_LINKS.home.devices}`,
  10017: `${PAGES_LINKS.home.root}${PAGES_LINKS.quickAccess.usage}`,
  20000: PAGES_LINKS.service.root,
  20001: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}?catType=3G`,
  20003: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}?catType=Min`,
  20002: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}?catType=SMS`,
  20004: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}?catType=CALLS`,
  20005: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}?catType=roaming`,
  20006: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.roaming.root}${PAGES_LINKS.service.roaming.international}${PAGES_LINKS.service.roaming.countryInfo}`,
  20007: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.roaming.root}${PAGES_LINKS.service.roaming.international}${PAGES_LINKS.service.roaming.tipsPage}`,
  20008: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.roaming.root}${PAGES_LINKS.service.roaming.international}`,
  20009: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.transferBalance}`,
  20010: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.vas}`,
  20011: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.connectYourLine}`,
  20012: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.MCN}`,
  20013: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectedNumber}`,
  20014: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectYourNumber}`,
  20015: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.temporaryDeactivation}`,
  20016: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.callMeBack}`,
  20017: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.simSwap}`,
  20018: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.balanceHistory}`,
  20019: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.giftSharing}`,
  20020: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.newSubscriptionRequest.root}${PAGES_LINKS.service.newSubscriptionRequest.otpVerification}?name=newSubscriptionRequest`,
  20021: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.speedUpgradeADSL.root}`,
  20022: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=zerosService&catType=zero`,
  20023: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=zerosService&catType=zero`,
  20024: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=billServices`,
  20025: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=billServices`,
  20026: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=fixedIP&catType=fixedip`,
  20027: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=fixedLineServices`,
  20028: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.points.root}`,
  20029: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=fixedLineServices`,
  20030: ``,
  20031: ``,
  20032: ``,
  20033: ``,
  20034: ``,
  20035: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=aman&catType=Aman`,
  20036: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.paltelBook.root}?name=paltel-book`,
  20037: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.uber}?name=uber`,
  20038: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.serviceDetails.root}?name=smartMesh&catType=mesh`,
  20039: ``,
  20040: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.recurringPayment}`,
  20041: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.microLoans}`,
  20042: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.maddedha}`,
  20044:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.ramadan.ramadanOffers}`,
  20058:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.directDebt}`,
  20076:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.routerSettings}`,
  20080:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.bundlePage}?catType=combo`,
  20081:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.payBillsForOthers}`,  
  20083:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.fiberTool}`,
  20085:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.simPukCode}`,
  20090:  `${PAGES_LINKS.service.root}${PAGES_LINKS.service.selectedNumberCampaign}`,
  30000: PAGES_LINKS.store,
  40000: PAGES_LINKS.more.root,
  40001: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.transactionHistory}`,
  40002: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}`,
  40003: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.settings}`,
  40004: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.jawwalApp}`,
  40005: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.termsAndCondition}`,
  40006: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.share}`,
  40007: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.aboutApp}`,
  40008: `${PAGES_LINKS.more.root}?isCorporateSessionEnd=true`,
  40009: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.iframePage}?iframeKey=Chatbot`,
  40011: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.iframePage}?iframeKey=VideoChat`,
  40012: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.rating}`,
  40013: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.iframePage}?iframeKey=FAQ`,
  40014: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.showrooms}?type=showrooms`,
  40015: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.callUs}`,
  40016: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.followUp}`,
  40017: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.numberManagement}`,
  40018: `${PAGES_LINKS.more.root}${PAGES_LINKS.more.supportAndHelp.root}${PAGES_LINKS.more.supportAndHelp.troubleTicket}`,
  40019: `${PAGES_LINKS.service.root}${PAGES_LINKS.service.orderTracking.root}`,
  50000: PAGES_LINKS.profile,
  909090: ``,
}

export default routingMappingDic
